var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"woven-strip size-small wobble",class:_vm.loading ? 'animating' : ''},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }